// services/choiceService.js

import apiClient from './apiClient';

export const getChoicesByQuestionId = async (questionId) => {
  return await apiClient.post('/question/getchoicesbyquestionid', null, {
    params: { id: questionId }
  });
};

export const addChoice = async (dto) => {
  const resp = await apiClient.post('/question/addchoice', dto);
  return resp.data;
};

export const updateChoice = async (dto) => {
  const resp = await apiClient.post('/question/updatechoice', dto);
  return resp.data;
};

export const deleteChoice = async (id) => {
  const resp = await apiClient.post('/question/deletechoice', null, {
    params: { id }
  });
  return resp.data;
};
